import styled from 'styled-components';

export const ClientSettingsDropdownListContainerBox = styled.div`
    position: relative;
    padding-block-end: 5px;

    &:nth-of-type(even)::before {
        content: "";
        position: absolute;
        top: 10px;
        left: -16px;

        box-sizing: content-box;
        background: ${({ theme }) => theme.colors.backgroundDark};
        box-shadow: 0.35px 0px 0px 0px ${({ theme }) => theme.colors.boxBorderContrast};
        width: 1px;
        height: calc(100% - 15px);
    }
`;